import {
  Button,
  DirectionProvider,
  Drawer,
  Group,
  Modal,
  ScrollArea,
  Stack,
  Text,
} from "@mantine/core";
import moment from "moment-jalaali";
import { useEffect, useState } from "react";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { Calendar } from "react-multi-date-picker";
import "./style.css";
import useIsSmall from "@/hooks/useIsSmall";

type Props = {
  openedCalender: boolean;
  closeCalender: () => void;
  setSelectedDate: (date: moment.Moment) => void;
};

function EditDate({ openedCalender, closeCalender, setSelectedDate }: Props) {
  const [calendarKey, setCalendarKey] = useState(0);
  const isSmall = useIsSmall();
  const selectNewDate = (date: moment.Moment) => {
    setSelectedDate(date);
    closeCalender();
  };

  // Force re-render when drawer opens to ensure styles are applied
  useEffect(() => {
    if (openedCalender) {
      setCalendarKey((prev) => prev + 1);
    }
  }, [openedCalender]);

  const quickSelectItems = [
    { id: 1, name: "امروز", value: moment() },
    { id: 2, name: "فردا", value: moment().add(1, "day") },
    { id: 3, name: "یک هفته بعد", value: moment().add(1, "week") },
    { id: 4, name: "دو هفته بعد", value: moment().add(2, "week") },
    { id: 5, name: "سه هفته بعد", value: moment().add(3, "week") },
    { id: 6, name: "چهار هفته بعد", value: moment().add(4, "week") },
  ];

  const content = (
    <Stack pt="md" justify="space-between">
      <Calendar
        key={calendarKey}
        className="custom-calendar"
        calendar={persian}
        locale={persian_fa}
        onChange={(date) => {
          date && selectNewDate(moment(new Date(date.valueOf())));
        }}
      />
      <Stack>
        <Text size="xs" c="dimmed">
          انتخاب سریع
        </Text>
        <DirectionProvider initialDirection="rtl">
          <ScrollArea pb="md">
            <Group wrap="nowrap" gap="xs" style={{ alignItems: "flex-start" }}>
              {quickSelectItems.map((item) => (
                <Button
                  size="sm"
                  variant="default"
                  radius="xl"
                  key={item.id}
                  style={{ flexShrink: 0, width: "auto" }}
                  onClick={() => selectNewDate(item.value)}
                >
                  <Text size="xs">{item.name}</Text>
                </Button>
              ))}
            </Group>
          </ScrollArea>
        </DirectionProvider>
      </Stack>
    </Stack>
  );

  return isSmall ? (
    <Drawer
      opened={openedCalender}
      onClose={closeCalender}
      size="md"
      position="bottom"
      radius="md"
      title="ویرایش تاریخ"
    >
      {content}
    </Drawer>
  ) : (
    <Modal opened={openedCalender} onClose={closeCalender} title="ویرایش تاریخ">
      {content}
    </Modal>
  );
}

export default EditDate;
